<div class="flex items-center">
  <label class="toggle-switch">
    <input
      type="checkbox"
      class="toggle-input sr-only"
      [checked]="selectedOption === options[0]"
      (change)="onToggleChange($event)"
      aria-label="Toggle"
    />
    <span class="toggle-slider"></span>
  </label>
</div>
